"use strict";
/**
 * Copyright (c) Hathor Labs and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const opcodes_1 = require("../opcodes");
const bitcore_lib_1 = require("bitcore-lib");
const helpers_1 = __importDefault(require("../utils/helpers"));
const buffer_1 = __importDefault(require("buffer"));
class ScriptData {
    constructor(data) {
        if (!data) {
            throw Error('You must provide data.');
        }
        this.data = data;
    }
    /**
     * Get script type
     *
     * @return {String}
     * @memberof ScriptData
     * @inner
     */
    getType() {
        return 'data';
    }
    /**
     * Create an output script from data
     *
     * @return {Buffer}
     * @memberof ScriptData
     * @inner
     */
    createScript() {
        const arr = [];
        const dataBytes = buffer_1.default.Buffer.from(this.data, 'utf8');
        helpers_1.default.pushDataToStack(arr, dataBytes);
        arr.push(opcodes_1.OP_CHECKSIG);
        return bitcore_lib_1.util.buffer.concat(arr);
    }
}
exports.default = ScriptData;
//# sourceMappingURL=script_data.js.map